import React from 'react';

// import { NavLink } from "react-router-dom"
import NavLinkOrA from './NavLinkOrA';

class Header extends React.Component {
  state = {
    scrolled: false,
  };

  constructor(props) {
    super(props)
    this.getClassName = this.getClassName.bind(this)
    this.onScroll = this.onScroll.bind(this)
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll)
  }

  onScroll() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop
    if (scrollTop > 44) {
      this.setState({ scrolled: true })
    } else {
      this.setState({ scrolled: false })
    }
  }

  getClassName() {
    let scrolled = this.state.scrolled ? ' scrolled' : ''
    return 'header' + scrolled
  }

  render() {
    return (
      <div className={this.getClassName()}>
        <div className="header__top">
          <div className="wd">
            <p className="header__kassa">Каса: <a className="header__kassa__link" href="tel:+380673299830">(067)
              329-98-30</a></p>
          </div>
        </div>
        <div className="header__bottom">
          <div className="wd">
            <NavLinkOrA is404={this.props.is404} to="/">
              {/* <img src="/img/logo/logo.svg" className="header__logo__flag" alt=""/> */}
              {/* <img src="/img/logo_txt.svg" className="header__logo__txt" alt=""/> */}
              {/* <img src="/img/santa_hat.png" className="header__logo__hat" alt="hat"/>               */}
              <img src="/img/logo/logo.svg" className="header__logo__90" alt="Logo" />
            </NavLinkOrA>
            {/* <img src="/img/logo_2.svg" className="header__altlogo" alt="Кінотеатр Жовтень" /> */}
            <ul className="header__navigation">
              <li><NavLinkOrA is404={this.props.is404} activeClassName="selected" to="/sessions">Сеанси</NavLinkOrA>
              </li>
              {/* <li><NavLinkOrA is404={this.props.is404} activeClassName="selected" to="/promotions">Акції та новини</NavLinkOrA ></li>
              <li><NavLinkOrA is404={this.props.is404} activeClassName="selected" to="/original-language">Original Language</NavLinkOrA ></li>
              <li><NavLinkOrA is404={this.props.is404} activeClassName="selected" to="/halls">Зали</NavLinkOrA ></li> */}
              <li><NavLinkOrA is404={this.props.is404} activeClassName="selected" to="/soon">Скоро у прокаті</NavLinkOrA></li>
              <li><NavLinkOrA is404={this.props.is404} activeClassName="selected" to="/history">Історія</NavLinkOrA></li>
              <li><NavLinkOrA is404={this.props.is404} activeClassName="selected" to="/contacts">Контакти</NavLinkOrA></li>
            </ul>
            <ul className="header__soc">
              <li><a target="_blank" href="http://instagram.com/zhovten.cinema" className="ig"><img
                src="/img/header_ig.svg" alt="Instagram" /></a></li>
              <li><a target="_blank" href="https://www.facebook.com/zhovten/"><img src="/img/header_fb.svg"
                alt="Facebook" /></a></li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export default Header


// WEBPACK FOOTER //
// ./src/components/snippets/Header.jsx